module.exports = __webpack_public_path__ + "static/media/Frame 2817.a65e1633.jpg";